// eslint-disable-next-line import/no-anonymous-default-export
export default {
  drawerWidth: 240,
  drawerWidthClose: 72,
};
